var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35983 12C5.57553 14.7936 8.22615 16.7234 11.5 16.7234C14.7738 16.7234 17.4245 14.7936 18.6402 12C17.4245 9.20637 14.7738 7.2766 11.5 7.2766C8.22615 7.2766 5.57553 9.20636 4.35983 12ZM3.0448 11.7678C4.38833 8.40934 7.54496 6 11.5 6C15.455 6 18.6117 8.40934 19.9552 11.7678C20.0149 11.9171 20.0149 12.0829 19.9552 12.2322C18.6117 15.5907 15.455 18 11.5 18C7.54496 18 4.38833 15.5907 3.0448 12.2322C2.98507 12.0829 2.98507 11.9171 3.0448 11.7678ZM11.5 10.3404C10.5611 10.3404 9.8 11.0834 9.8 12C9.8 12.9166 10.5611 13.6596 11.5 13.6596C12.4389 13.6596 13.2 12.9166 13.2 12C13.2 11.0834 12.4389 10.3404 11.5 10.3404ZM8.49231 12C8.49231 10.3784 9.8389 9.06383 11.5 9.06383C13.1611 9.06383 14.5077 10.3784 14.5077 12C14.5077 13.6216 13.1611 14.9362 11.5 14.9362C9.8389 14.9362 8.49231 13.6216 8.49231 12Z",
    fill: "#3d3d3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.302ad349c16785db8156e6e9500e9cd4.svg";
export { ForwardRef as ReactComponent };